import { isLocaleSupported, type SupportedLocale } from './locale-constants';

export const STORED_LOCALE_KEY = 'i18nextLng';

const OKTA_TOKEN_STORAGE_KEY = 'okta-token-storage';

type OktaTokenStorage = {
  idToken?: { claims?: { preferred_username?: string } };
};

// Direct read: helpers/localStorage would pull the native-auth bridge into i18n init.
const getOktaUsername = (): string | undefined => {
  try {
    const stored = localStorage.getItem(OKTA_TOKEN_STORAGE_KEY);
    return stored
      ? (JSON.parse(stored) as OktaTokenStorage)?.idToken?.claims
          ?.preferred_username
      : undefined;
  } catch {
    return undefined;
  }
};

export const storedLocaleKey = (): string => {
  const username = getOktaUsername();
  return username ? `${STORED_LOCALE_KEY}:${username}` : STORED_LOCALE_KEY;
};

// Safari private mode throws on localStorage instead of returning null.
export const getStoredLocale = (): SupportedLocale | undefined => {
  try {
    const stored = localStorage.getItem(storedLocaleKey());
    return stored && isLocaleSupported(stored) ? stored : undefined;
  } catch {
    return undefined;
  }
};

export const storeLocale = (locale: SupportedLocale): void => {
  try {
    localStorage.setItem(storedLocaleKey(), locale);
  } catch {
    // Next boot falls back to the browser locale.
  }
};

export const clearStoredLocale = (): void => {
  try {
    localStorage.removeItem(storedLocaleKey());
  } catch {
    // The next login overwrites the stale value.
  }
};
